<template>
  <div class="order-details" style="padding-top: 1rem;">
    <!--<navTitle title="积分订单详情" path='/order/integral/list/1' color="#fff"></navTitle>-->
    <navTitle :title="
        $router.app._route.query.ti
          ? $router.app._route.query.ti
          : 'Detail poin'
      " path="/order/integral/list/1" color="#fff"></navTitle>

    <!-- 给header上与data上加on为退款订单-->
    <div class="header  acea-row row-middle" style="background: #FBFBFB;color: #333" :class="refundOrder ? 'on' : ''">
      <!--<div class="pictrue" v-if="!refundOrder">-->
      <!--<img :src="orderInfo.status_pic" />-->
      <!--</div>-->
      <div class="data" :class="refundOrder ? 'on' : ''">
        <div class="state">{{ orderInfo._status._msg }}</div>
        <div>
          {{ orderInfo.add_time_y
          }}<span class="time">{{ orderInfo.add_time_h }}</span>
        </div>
      </div>
    </div>
    <template v-if="!refundOrder">
      <div v-if="orderInfo.real_name != ''">
        <div class="address" v-if="orderInfo.shipping_type === 1">
          <div class="name">
            {{ orderInfo.real_name
            }}<span class="phone">{{ orderInfo.user_phone }}</span>
          </div>
          <div>{{ orderInfo.user_address }}</div>
        </div>

        <div class="line" v-if="orderInfo.shipping_type === 1">
          <img src="@assets/images/line.jpg" />
        </div>
      </div>
    </template>
    <OrderGoods :evaluate="orderInfo.product_info.id" :cartInfo="orderInfo.product_info"></OrderGoods>
    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>Order No:</div>
        <div class="conter acea-row row-middle row-right">
          {{ orderInfo.order_id
          }}<span class="copy copy-data" :data-clipboard-text="orderInfo.order_id">Copy</span>
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>Order time:</div>
        <div class="conter">
          {{ orderInfo.add_time_y + " " + orderInfo.add_time_h }}
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>Type of order:</div>
        <div class="conter">
          {{ orderTypeName }}
        </div>
      </div>

      <div class="item acea-row row-between" v-if="orderInfo.mark">
        <div>Customer message:</div>
        <div class="conter">{{ orderInfo.mark }}</div>
      </div>
    </div>

    <!--{{orderInfo}}-->
    <!--     退款订单详情 -->

    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>Total Amount:</div>
        <div class="conter">{{ orderInfo.total_integral }}Points</div>
      </div>

      <div class="actualPay acea-row row-right">
        Amount paid:
        <!--<span class="money font-color-red" v-if="orderInfo.game_state==2">{{ orderInfo.up_total_price }}</span>-->
        <span class="money font-color-red">{{ orderInfo.total_integral }}Points</span>
      </div>
    </div>
    <div style="height:1.2rem;" v-if="!refundOrder && offlineStatus"></div>

    <Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money"></Payment>
    <div class="geoPage" v-if="mapShow">
      <iframe width="100%" height="100%" frameborder="0" scrolling="no" :src="
          'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
            system_store.latitude +
            ',' +
            system_store.longitude +
            '&referer=' +
            mapKey
        ">
      </iframe>
    </div>
  </div>
</template>
<style scoped>
  .geoPage {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 10000;
  }

  .order-details .writeOff {
    background-color: #fff;
    margin-top: 0.13rem;
    padding-bottom: 0.3rem;
  }

  .order-details .writeOff .title {
    font-size: 0.3rem;
    color: #282828;
    height: 0.87rem;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 0.3rem;
    line-height: 0.87rem;
  }

  .order-details .writeOff .grayBg {
    background-color: #f2f5f7;
    width: 5.9rem;
    height: 3.84rem;
    border-radius: 0.2rem 0.2rem 0 0;
    margin: 0.5rem auto 0 auto;
    padding-top: 0.55rem;
  }

  .order-details .writeOff .grayBg .pictrue {
    width: 2.9rem;
    height: 2.9rem;
    margin: 0 auto;
  }

  .order-details .writeOff .grayBg .pictrue img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .order-details .writeOff .gear {
    width: 5.9rem;
    height: 0.3rem;
    margin: 0 auto;
  }

  .order-details .writeOff .gear img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .order-details .writeOff .num {
    background-color: #f0c34c;
    width: 5.9rem;
    height: 0.84rem;
    color: #282828;
    font-size: 0.48rem;
    margin: 0 auto;
    border-radius: 0 0 0.2rem 0.2rem;
    text-align: center;
    padding-top: 0.04rem;
  }

  .order-details .writeOff .rules {
    margin: 0.46rem 0.3rem 0 0.3rem;
    border-top: 0.01rem solid #f0f0f0;
    padding-top: 0.1rem;
  }

  .order-details .writeOff .rules .item {
    margin-top: 0.15rem;
  }

  .order-details .writeOff .rules .item .rulesTitle {
    font-size: 0.28rem;
    color: #282828;
  }

  .order-details .writeOff .rules .item .rulesTitle .iconfont {
    font-size: 0.3rem;
    color: #333;
    margin-right: 0.08rem;
    margin-top: 0.05rem;
  }

  .order-details .writeOff .rules .item .info {
    font-size: 0.28rem;
    color: #999;
    margin-top: 0.05rem;
  }

  .order-details .writeOff .rules .item .info .time {
    margin-left: 0.2rem;
  }

  .order-details .map {
    height: 0.86rem;
    font-size: 0.3rem;
    color: #282828;
    line-height: 0.86rem;
    border-bottom: 0.01rem solid #f0f0f0;
    margin-top: 0.13rem;
    background-color: #fff;
    padding: 0 0.3rem;
  }

  .order-details .map .place {
    font-size: 0.26rem;
    width: 1.76rem;
    height: 0.5rem;
    border-radius: 0.25rem;
    line-height: 0.5rem;
    text-align: center;
  }

  .order-details .map .place .iconfont {
    font-size: 0.27rem;
    height: 0.27rem;
    line-height: 0.27rem;
    margin: 0.02rem 0.03rem 0 0;
  }

  .order-details .address .name .iconfont {
    font-size: 0.34rem;
    margin-left: 0.1rem;
  }

  .btn-red {
    border: 1px solid #da2d2d;
    color: #da2d2d;
  }

  .btn-blue {
    border: 1px solid #00c3f9;
    color: #00c3f9;
  }

  .btn-gray {
    border: 1px solid #999999;
    color: #999999;
  }

  .btn-yellow {
    border: 1px solid #fcbb01;
    color: #fcbb01;
  }
</style>
<script>
  import OrderGoods from "@components/IntegralOrderGoods";
  import navTitle from "@components/navTitle";
  import { detail_integral } from "@api/integral";
  import ClipboardJS from "clipboard";
  import Payment from "@components/Payment";
  import { isWeixin } from "@utils";
  import { mapGetters } from "vuex";
  import {
    cancelOrderHandle,
    takeOrderHandle,
    delOrderHandle,
    payOrderHandle
  } from "@libs/order";
  import { wechatEvevt } from "@libs/wechat";

  const NAME = "OrderDetails";

  export default {
    name: NAME,
    components: {
      OrderGoods,
      Payment,
      navTitle
    },
    props: {},
    data: function () {
      return {
        offlinePayStatus: 2,
        orderTypeName: "Normal order",
        orderTypeNameStatus: true,
        offlineStatus: true,
        id: this.$route.params.id,
        orderInfo: {
          _status: {}
        },
        status: {},
        pay: false,
        payType: ["yue", "weixin"],
        from: isWeixin() ? "weixin" : "weixinh5",
        system_store: {},
        mapKay: "",
        mapShow: false
      };
    },
    computed: {
      refundOrder() {
        return this.orderInfo.refund_status > 0;
      },
      ...mapGetters(["userInfo"])
    },
    watch: {
      $route(n) {
        if (n.name === NAME && this.id !== n.params.id) {
          this.id = n.params.id;
          this.getDetail();
        }
      }
    },
    inject: ["app"],
    mounted: function () {
      this.getDetail();
      this.$nextTick(function () {
        let copybtn = document.getElementsByClassName("copy-data");
        const clipboard = new ClipboardJS(copybtn);
        clipboard.on("success", () => {
          this.$dialog.success("Copy success");
        });
      });
    },
    methods: {
      showChang: function () {
        if (isWeixin()) {
          let config = {
            latitude: parseFloat(this.system_store.latitude),
            longitude: parseFloat(this.system_store.longitude),
            name: this.system_store.name,
            address: this.system_store._detailed_address
          };
          wechatEvevt("openLocation", config)
            .then(res => { })
            .catch(res => {
              if (res.is_ready) {
                res.wx.openLocation(config);
              }
            });
        } else {
          if (!this.mapKey)
            return this.$dialog.error(
              "Map currently unavailable"
            );
          this.mapShow = true;
        }
      },
      goBack() {
        const history = this.app.history,
          last = history[history.length - 1] || {};
        if (last.name === "MyOrder") return this.$router.go(-1);
        else return this.$router.replace({ path: "/order/list/" });
      },
      cancelOrder() {
        cancelOrderHandle(this.orderInfo.order_id)
          .then(() => {
            setTimeout(() => this.goBack(), 300);
          })
          .catch(() => {
            this.getDetail();
          });
      },
      takeOrder() {
        takeOrderHandle(this.orderInfo.order_id).finally(() => {
          this.getDetail();
        });
      },
      delOrder() {
        delOrderHandle(this.orderInfo.order_id).then(() => {
          setTimeout(() => this.goBack(), 300);
        });
      },
      setOfflinePayStatus: function (status) {
        var that = this;
        that.offlinePayStatus = status;
        if (status === 1 && that.orderTypeNameStatus === true) {
          that.payType.push("offline");
        }
      },
      getOrderStatus: function () {
        let orderInfo = this.orderInfo || {},
          _status = orderInfo._status || { _type: 0 },
          status = {};
        let type = parseInt(_status._type),
          delivery_type = orderInfo.delivery_type,
          seckill_id = orderInfo.seckill_id ? parseInt(orderInfo.seckill_id) : 0,
          bargain_id = orderInfo.bargain_id ? parseInt(orderInfo.bargain_id) : 0,
          combination_id = orderInfo.combination_id
            ? parseInt(orderInfo.combination_id)
            : 0;
        status = {
          type: type,
          class_status: 0
        };
        if (type === 1 && combination_id > 0) {
          status.type = 6;
          status.class_status = 1;
        } //查看拼团
        if (type === 2 && delivery_type === "express") status.class_status = 2; //查看物流
        if (type === 2) status.class_status = 3; //确认收货
        if (type === 4 || type === 0) status.class_status = 4; //删除订单
        if (
          !seckill_id &&
          !bargain_id &&
          !combination_id &&
          (type === 3 || type === 4)
        )
          status.class_status = 5; //再次购买
        if (type == 9) {
          //线下付款
          status.class_status = 0;
          this.offlineStatus = false;
        }
        this.status = status;
      },
      getDetail() {
        const id = this.id;
        if (!id) return this.$dialog.error("Order does not exist");
        detail_integral(id)
          .then(res => {
            this.orderInfo = res.data;
            this.getOrderStatus();

            this.system_store = res.data.system_store || {};
            this.mapKey = res.data.mapKey;
            this.setOfflinePayStatus(this.orderInfo.offlinePayStatus);
          })
          .catch(err => {
            this.$dialog.error(err.msg);
          });
      },
      async toPay(type) {
        var that = this;
        await payOrderHandle(this.orderInfo.order_id, type, that.from)
          .then(() => { })
          .catch(res => {
            if (res.status === "WECHAT_H5_PAY")
              that.$router.push({
                path: "/order/status/" + that.orderInfo.order_id + "/0"
              });
          });
        that.getDetail();
      }
    }
  };
</script>